import { cpRequestUseCase } from '../../usecases'
import { ref, onMounted } from '@vue/composition-api'

const useCampaigns = (userId) => { 

    const campaigns = ref(null)
    const loader = ref(false)

    onMounted(async () => {
        loader.value = true;
        try {
            campaigns.value = await cpRequestUseCase.getOwnerCampaigns(userId)
        } catch(err) {
            console.log(err)
        } finally {
            loader.value = false;
        }
    })

    return {
        campaigns,
        loader
    }

}

export default useCampaigns;